import { render } from "./SwitchToggle.vue?vue&type=template&id=0758a8ce&scoped=true&ts=true"
import script from "./SwitchToggle.vue?vue&type=script&lang=ts"
export * from "./SwitchToggle.vue?vue&type=script&lang=ts"

import "./SwitchToggle.vue?vue&type=style&index=0&id=0758a8ce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0758a8ce"]])

export default __exports__